import React, {
  useCallback,
  useContext,
  useMemo,
  useState,
  useEffect,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, Button } from "reactstrap";
import _ from "lodash";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import "./cmtIssue.css";
import { green } from "@mui/material/colors";
import CmtIssueDetail_Left from "./CmtIssueDetail_Left";
import CmtIssueDetail_Right from "./CmtIssueDetail_Right";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CmtModal_EditIssueStage from "./CmtModal_EditIssueStage";
import { QMS } from "../../../_constants/actionConstants";
import CmtModal_ApplyWorkflow from "./CmtModal_ApplyWorkflow";
import qmsWorkflowActions from "../../../_actions/_qmsActions/qmsWorkflowActions";
import CmtModal_ViewWorkflow from "./CmtModal_ViewWorkflow";

export default function CmtIssueDetails(props) {
  const {
    issueId,
    tabId,
    editIsAuthorized_tt,
    editIsAuthorized_qmr,
    detailViewIsAuthorized,
    selectedStageId,
    selectStage,
  } = props;

  const dispatch = useDispatch();
  const fetching = useSelector((state) => state.qms.fetching);
  const qmsUser = useSelector((state) => state.qms.qmsUser || null);
  const issue = useSelector((state) => state.qms.openIssues[issueId] || null);
  const issueStage = useSelector((state) => state.qms.openIssueStages[issueId] || null);
  const qmsTeams = useSelector((state) =>
    issue ? state.qms.qmsTeams[issue.divisionId] || null : null
  );
  const workflows = useSelector((state) => state.qms.openWorkflowLists[tabId] || null);

  const [timelineFilter, setTimelineFilter] = useState("all");

  const [modalState_applyWorkflow, setModalState_applyWorkflow] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_applyWorkflow = () =>
    setModalState_applyWorkflow({
      ...modalState_applyWorkflow,
      showModal: !modalState_applyWorkflow.showModal,
    });

  const [modalState_editStage, setModalState_editStage] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_addStage = () =>
    setModalState_editStage({
      ...modalState_editStage,
      showModal: !modalState_editStage.showModal,
    });

  const [showModal_viewWorkflow, _setShowModal_viewWorkflow] = useState(false);
  const toggleModal_viewWorkflow = () =>
    _setShowModal_viewWorkflow(!showModal_viewWorkflow);

  const selectLatestCurrentStageId = () => {
    if (!issue || !("issueStageSnippets" in issue)) {
      return null;
    }

    // If no stages, select initiated
    if ((issue.issueStageSnippets || []).length === 0) return "initiated";

    // There could be multiple stages marked current
    const currentStages = (issue.issueStageSnippets || []).filter((iss) => iss.isCurrent);
    if (currentStages.length === 0) {
      return null;
    }

    const sortedStages = _.orderBy(currentStages, "startedOn", "desc");
    return sortedStages[0].issueStageId;
  };

  // const [selectedStageId, selectStage] = useState(selectLatestCurrentStageId());
  useEffect(() => selectLatestCurrentStageId(), []);

  // When issue loads, select latest current stage, and load all workflows
  useEffect(() => {
    if (issue) {
      dispatch(qmsWorkflowActions.getAll(issue.divisionId, tabId));
    }
  }, [issue]);

  // When selected issue stage changes, load the full issue stage data
  useEffect(() => {
    if (issue && selectedStageId) {
      if (selectedStageId !== "initiated")
        dispatch(cmtIssueStageActions.get(issueId, selectedStageId));
    } else dispatch({ type: QMS.ISSUE_STAGE.CLEAR, issueId });
  }, [selectedStageId]);

  const appliedWorkflowName = useMemo(() => {
    if (issue && issue.appliedWorkflowId) {
      const wf = (workflows || []).find((w) => w.workflowId === issue.appliedWorkflowId);
      return wf ? wf.name || "(N/A)" : "(N/A)";
    }
  }, [issue, workflows]);

  const handleClick_applyWorkflow = (e) => {
    e.preventDefault();
    setModalState_applyWorkflow({ showModal: true, data: null });
  };

  const handleClick_editWorkflow = (e) => {
    e.preventDefault();
    setModalState_applyWorkflow({
      showModal: true,
      data: { workflowId: issue.appliedWorkflowId },
    });
  };

  // Used by Timeline and Details
  const getOwnerTeamLabel = useCallback(
    (issueStageId) => {
      const issueStage = (issue.issueStageSnippets || []).find(
        (iss) => iss.issueStageId === issueStageId
      );
      // Note: ownerTeamId is a nullable property
      const ownerTeam =
        issueStage && issueStage.ownerTeamId
          ? (qmsTeams || []).find((qt) => qt.qmsTeamId === issueStage.ownerTeamId)
          : null;
      return ownerTeam ? ownerTeam.name : "(N/A)";
    },
    [issue, qmsTeams]
  );

  const getStageTitle = useCallback(
    (selectedStageId) => {
      if (!selectedStageId) return "(No Stage Selected)";
      if (selectedStageId !== "initiated") {
        const issueStage = issue
          ? (issue.issueStageSnippets || []).find(
              (iss) => iss.issueStageId === selectedStageId
            )
          : null;
        return issueStage ? issueStage.title : "(N/A)";
      }
      return "Initiated";
    },
    [issue, selectedStageId]
  );

  const renderDetailArea = () => {
    if (selectedStageId === "initiated") {
      return (
        <div className="d-flex flex-row w-100">
          <div className="card-body">
            <b>Initiated</b>
          </div>
        </div>
      );
    }
    return (
      <div className="d-flex flex-row w-100">
        <div className="card issue-stage-details-summary mr-2">
          <div className="card-body">
            <CmtIssueDetail_Left
              issueStage={issueStage}
              getOwnerTeamLabel={getOwnerTeamLabel}
              showModal_editStage={(data) =>
                setModalState_editStage({
                  showModal: true,
                  data: { ...modalState_editStage.data, ...data, isEdit: true },
                })
              }
              deleteCallback={selectStage}
              divisionId={issue ? issue.divisionId : 0}
            />
          </div>
        </div>
        <div className="card issue-stage-details-updates">
          <div className="card-body">
            <CmtIssueDetail_Right
              issue={issue}
              issueStage={issueStage}
              selectedStageId={selectedStageId}
              qmsUserId={qmsUser.qmsUserId}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="font-weight-bold">Timeline</div>
      <div className="card w-100 bg-lightgray mb-1">
        <div className="card-body d-flex flex-row p-2">
          <div className="my-auto mr-2">
            <ButtonGroup size="sm">
              <Button
                name="all"
                id="filterAll"
                color="secondary"
                outline
                onClick={() => setTimelineFilter("all")}
                active={timelineFilter === "all"}
                disabled={fetching}
              >
                Show All
              </Button>
              <Button
                name="currentOnly"
                id="filterCurrentOnly"
                color="secondary"
                outline
                onClick={() => setTimelineFilter("currentOnly")}
                active={timelineFilter === "currentOnly"}
                disabled={fetching}
              >
                Current Only
              </Button>
            </ButtonGroup>
          </div>
          {issue &&
            issue.isOpen &&
            (!issue.appliedWorkflowId && editIsAuthorized_tt ? (
              <div className="my-auto">
                <button
                  name="applyWorkflow"
                  id="applyWorkflow"
                  className="btn btn-sm btn-secondary"
                  onClick={handleClick_applyWorkflow}
                >
                  <FontAwesomeIcon icon="code-branch" className="fa-fw mr-1" />
                  Apply Workflow...
                </button>
              </div>
            ) : (
              issue.appliedWorkflowId && (
                <div className="card my-auto p-0">
                  <div className="card-body py-1 px-2">
                    <span className="mr-2">Applied Workflow:</span>
                    <button
                      className="btn btn-link btn-sm py-0"
                      type="button"
                      onClick={toggleModal_viewWorkflow}
                    >
                      <b>
                        <FontAwesomeIcon icon="code-branch" className="mr-2" />
                        {appliedWorkflowName}
                      </b>
                    </button>
                    {/* <button
                  id="applyWorkflow"
                  name="applyWorkflow"
                  className="btn btn-link btn-sm align-top py-0 px-1 ml-2"
                  onClick={handleClick_editWorkflow}
                >
                  <FontAwesomeIcon icon="edit" className="fa-fw mr-0" />
                  Change...
                </button> */}
                  </div>
                </div>
              )
            ))}
        </div>
      </div>
      <div className="d-flex flex-row w-100 mb-2 p-2 border">
        {issue ? (
          <CmtIssueTimeline
            issue={issue}
            selectedStageId={selectedStageId}
            selectStage={selectStage}
            timelineFilter={timelineFilter}
            handleClick_addStage={() =>
              setModalState_editStage({
                showModal: true,
                data: null,
              })
            }
            getOwnerTeamLabel={getOwnerTeamLabel}
            editIsAuthorized_tt={editIsAuthorized_tt}
            editIsAuthorized_qmr={editIsAuthorized_qmr}
          />
        ) : (
          "Loading..."
        )}
      </div>
      <div className="card bg-lightgray mb-2">
        <div className="card-body p-2">
          <h2 className="text-center">{getStageTitle(selectedStageId)}</h2>
        </div>
      </div>
      {detailViewIsAuthorized
        ? issueStage
          ? renderDetailArea()
          : fetching
          ? "Loading..."
          : "No stage selected."
        : "You do not have sufficient privileges to view details for this issue."}
      {modalState_editStage.showModal && (
        <CmtModal_EditIssueStage
          modalState={modalState_editStage}
          toggleModal={toggleModal_addStage}
          issue={issue}
          qmsUserId={qmsUser ? qmsUser.qmsUserId : null}
          selectStage={selectStage}
        />
      )}
      {modalState_applyWorkflow.showModal && (
        <CmtModal_ApplyWorkflow
          modalState={modalState_applyWorkflow}
          toggleModal={toggleModal_applyWorkflow}
          issueId={issueId}
          divisionId={issue ? issue.divisionId : 0}
          tabId={tabId}
        />
      )}
      {showModal_viewWorkflow && (
        <CmtModal_ViewWorkflow
          showModal={showModal_viewWorkflow}
          toggleModal={toggleModal_viewWorkflow}
          workflowId={issue ? issue.appliedWorkflowId : 0}
        />
      )}
    </>
  );
}

function CmtIssueTimeline(props) {
  const {
    issue,
    selectedStageId,
    selectStage,
    timelineFilter,
    handleClick_addStage,
    getOwnerTeamLabel,
    editIsAuthorized_tt,
    editIsAuthorized_qmr,
  } = props;

  const issueIsChild = useMemo(() => issue && issue.parentIssueId, [issue]);

  // On load, scroll farthest to the left so right end of the div is shown.
  const timelineContainer = useRef();
  useEffect(() => {
    if (timelineContainer.current)
      timelineContainer.current.scrollLeft += timelineContainer.current.clientWidth;
  }, []);

  const sortedTimelineItems = useMemo(
    () =>
      _.orderBy(
        (issue.issueStageSnippets || []).filter(
          (iss) =>
            !timelineFilter ||
            timelineFilter === "all" ||
            (timelineFilter === "currentOnly" && iss.isCurrent)
        ),
        "startedOn",
        "asc"
      ),
    [issue, timelineFilter]
  );

  return (
    <div
      className="d-flex flex-row w-100 mb-2 issue-stage p-2 border"
      ref={timelineContainer}
    >
      {issue ? (
        <>
          {!issueIsChild && (
            <CmtIssueTimelineItem
              stageId="initiated"
              isCurrent={!issue.isAcknowledged && !issue.isClosed}
              isSelected={selectedStageId === "initiated"}
              handleClick={() => selectStage("initiated")}
            >
              <div className="d-flex flex-column p-2">
                <div
                  className={`text-center font-weight-bold ${
                    issue.isAcknowledged ? "text-muted" : ""
                  }`}
                >
                  Initiated
                </div>
                <div>
                  <span className="font-weight-bold mr-2">Date:</span>
                  {new Date(issue.initiatedOn).toLocaleDateString()}
                </div>
              </div>
            </CmtIssueTimelineItem>
          )}
          {sortedTimelineItems.map((iss, stageIndex) => (
            <CmtIssueTimelineItem
              key={`issueStageCardKey_${stageIndex}`}
              stageId={iss.issueStageId}
              isCurrent={iss.isCurrent}
              isSelected={iss.issueStageId === +selectedStageId}
              handleClick={() => selectStage(iss.issueStageId)}
            >
              <div className="d-flex flex-column p-2">
                <div
                  className={`text-center font-weight-bold ${
                    !iss.isCurrent && "text-muted"
                  }`}
                >
                  {iss.isFromWorkflow && (
                    <FontAwesomeIcon icon="code-branch" className="mr-1" />
                  )}
                  {iss.isSystemGenerated && (
                    <FontAwesomeIcon icon="lock" className="mr-1" />
                  )}
                  {iss.title || "(N/A)"}
                </div>
                {iss.isCompleted && !iss.isSystemGenerated && (
                  <div className="text-center font-weight-bold text-muted text-small">
                    [Completed]
                  </div>
                )}
                {iss.isCurrent && (
                  <div
                    className="text-center font-weight-bold text-small"
                    style={{ color: green }}
                  >
                    [Current]
                  </div>
                )}
                <div>
                  <span className="font-weight-bold mr-2">
                    {iss.isSystemGenerated ? "Date:" : "Start:"}
                  </span>
                  {iss.startedOn ? new Date(iss.startedOn).toLocaleDateString() : "(N/A)"}
                </div>
                {!iss.isSystemGenerated && (
                  <>
                    <div>
                      <span className="font-weight-bold mr-2">Finish:</span>
                      {iss.isCompleted
                        ? new Date(iss.completedOn).toLocaleDateString()
                        : "(N/A)"}
                    </div>
                    <div>
                      <span className="font-weight-bold mr-2">Owner:</span>
                      {getOwnerTeamLabel(iss.issueStageId)}
                    </div>
                  </>
                )}
              </div>
            </CmtIssueTimelineItem>
          ))}
          {issue.isOpen && editIsAuthorized_tt && (
            <div className="my-auto">
              <button
                className="btn btn-secondary px-4 py-3"
                onClick={handleClick_addStage}
              >
                <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
                Add...
              </button>
            </div>
          )}
        </>
      ) : (
        "Loading..."
      )}
    </div>
  );
}

function CmtIssueTimelineItem(props) {
  const { stageId, isCurrent, isSelected, handleClick } = props;

  return (
    <div
      className={`mr-2 issue-stage-item${isCurrent ? " current" : ""}${
        isSelected ? " bg-lightgreen" : ""
      }`}
      onClick={() => handleClick(stageId)}
    >
      {props.children}
    </div>
  );
}
